import { render, staticRenderFns } from "./minNews.vue?vue&type=template&id=3a3e0ccc&scoped=true"
import script from "./minNews.vue?vue&type=script&lang=js"
export * from "./minNews.vue?vue&type=script&lang=js"
import style0 from "./minNews.vue?vue&type=style&index=0&id=3a3e0ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e0ccc",
  null
  
)

export default component.exports